<app-checkbox [title]='"I have located and accepted the terms and conditions and the rules of use." | translate' [name]="'waiver'"
  [(ngModel)]="partner.waiver" (checkboxClick)="onCheckboxClick($event)" (checkboxChanged)="checkedChanged($event)" appRequiredTrue required></app-checkbox>
